module.exports = __webpack_public_path__ + "img/icon-password2.48e6064c.svg";